import styles from "./Checkbox.module.scss";

function Checkbox({
  type = "checkbox",
  name,
  value,
  subText,
  children,
  onChange,
  defaultValue,
  className,
  checked = false
}) {
  return (
    <>
      <label className={className}>
        <input
          checked={checked}
          type={type}
          value={value}
          name={name}
          onChange={onChange}
          defaultValue={defaultValue}
        ></input>
        <div></div>
        {children}
      </label>
      <p className={styles.subText}>{subText}</p>
    </>
  );
}
export default Checkbox;